import { Static, Type } from '@sinclair/typebox'

/**
 * inputUiInfo map, prop name → the dropdown option a write resolved, by the
 * model's own choice or the walker's auto-select. A dynamic dropdown's label
 * does not otherwise survive past the turn that picked it: `get_flow_debug_info`
 * would name the raw value ("formulaire n°42") instead of the user's word
 * ("Intervention").
 */
export const AI_BUILDER_SELECTED_LABELS = 'aiBuilderSelectedLabels'

/**
 * `value` is kept alongside `label` so a read can check the entry still
 * describes the current value: a later rewrite that does not invalidate the
 * entry never surfaces a stale label.
 */
export const SelectedLabelEntry = Type.Object({
    value: Type.Unknown(),
    label: Type.String(),
})
export type SelectedLabelEntry = Static<typeof SelectedLabelEntry>

export const SelectedLabelsMarker = Type.Record(Type.String(), SelectedLabelEntry)
export type SelectedLabelsMarker = Static<typeof SelectedLabelsMarker>
